export const filterSelectList = (list = [], val = '') => {
    if (val === '') return list;
    const options = list.filter(item => {
        return item.label.toLowerCase()
            .indexOf(val.toLowerCase()) > -1 || item.value.toLowerCase().indexOf(val.toLowerCase()) > -1;
    });
    return options;
}

// 格式化日期
export const formatDate = (Vue, times) => {
    let time = Vue.$moment.duration(times, "millisecond"); //得到一个对象，里面有对应的时分秒等时间对象值
    let hours = time.hours();
    let minutes = time.minutes();
    let seconds = time.seconds();
    return Vue.$moment({ h: hours, m: minutes, s: seconds }).format(
        "HH:mm:ss"
    );
}

export function strToBase64(str) {
    // 对字符串进行编码
    var encode = encodeURIComponent(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
}

export function base64ToStr(base64) {
    // 对base64转编码
    var decode = atob(base64);
    // 编码转字符串
    var str = decodeURIComponent(decode);
    return str;
}

// 字符串转数组  eg: 'a,2b,3,c' ==> ['a','2b','3','c'] 
export function formatStrToArr(val) {
    return val ? val.split(',') : [];
}

// 将英文名字转为中卫
export function formatEnToUtf8(obj = {}, str = '') {
    let nstr = ''
    formatStrToArr(str).forEach(s => {
        obj[s] && (nstr += obj[s] + ' ')
    })
    return nstr;
}

// 将英文名字转为中卫
export function formatEnToUtf8NoEn(obj = {}, str = '') {
    let nstr = ''
    formatStrToArr(str).forEach(s => {
        obj[s] && (nstr += obj[s].split('（')[0] + ' ')
    })
    return nstr;
}

// 毫秒值转 YYYY-MM-DD HH:mm:ss
export function formatTimeToDate(val,format){
    return val ? this.$moment(val).format(format) : ''
}